import * as React from 'react';

import { FormattedMessage, InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { forgotPassword } from 'actions/account';
import { Button } from 'components/Button';
import { Footer } from 'components/Footer';
import { Form } from 'components/Form';
import { FieldText, InputText } from 'components/Input';
import { LayoutFooter, LayoutTitle } from 'components/Layout';
import { LinkWithAnalytics } from 'components/LinkWithAnalytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'constants/analytics';
import { APPLICATION_FORM_NAME, ROUTE_LOGIN } from 'constants/app';
import { sendEvent } from 'helper/analytics';
import { injectIntl } from 'helper/redux';
import { validate } from 'helper/validation/account/accountForgotPasswordForm';
import { AccountForgotPasswordForm } from 'models/account';
import { AppState } from 'models/app';

import './AccountForgotPassword.scss';

interface StateProps {
  initialValues: AccountForgotPasswordForm;
}

interface DispatchProps {
  forgotPassword: typeof forgotPassword;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;
type AccountForgotPasswordProps = StateProps & DispatchProps & OwnProps;

@injectIntl()
class AccountForgotPasswordContainer extends React.Component<AccountForgotPasswordProps, {}> {
  private fieldUsername: FieldText;

  constructor(props: AccountForgotPasswordProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.setFieldUsernameReference = this.setFieldUsernameReference.bind(this);
  }

  componentDidMount() {
    (this.fieldUsername.getRenderedComponent() as InputText).focus();
  }

  render() {
    const { initialValues, intl } = this.props;
    return (
      <Form
        className="o-container o-container--fluid o-container--fluid-vertical"
        form={APPLICATION_FORM_NAME}
        initialValues={initialValues}
        onSubmit={this.onSubmit}
        validate={validate}
      >
        <LayoutTitle modifier="with-logo" title={intl.formatMessage({ id: 'account.forgot.password.title' })}/>
        <LayoutFooter><Footer/></LayoutFooter>

        <FieldText
          className="o-form-field"
          component={InputText}
          label={intl.formatMessage({ id: 'account.forgot.password.username' })}
          modifier="cancel"
          name="username"
          ref={this.setFieldUsernameReference}
          type="text"
          withRef={true}
        />

        <Button type="submit" className="o-form-button button--full button--primary">
          <FormattedMessage id="account.forgot.password.continue"/>
        </Button>

        <div className="account-forgot-password__login">
          <FormattedMessage id="account.register.login.pre"/>
          <LinkWithAnalytics
            className="account-forgot-password__login-link"
            to={ROUTE_LOGIN}
            category={AnalyticsEventCategory.ACCOUNT_FORGOT_PASSWORD}
            action={AnalyticsEventAction.OPEN_ACCOUNT_LOG_IN_PAGE}
          >
            <FormattedMessage id="account.register.login"/>
          </LinkWithAnalytics>
        </div>
      </Form>
    );
  }

  private onSubmit(formValue: AccountForgotPasswordForm) {
    sendEvent({
      action: AnalyticsEventAction.ACCOUNT_FORGOT_PASSWORD,
      category: AnalyticsEventCategory.ACCOUNT_FORGOT_PASSWORD
    });
    this.props.forgotPassword(formValue);
  }

  private setFieldUsernameReference(field: FieldText) {
    this.fieldUsername = field;
  }
}

export const AccountForgotPassword = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    initialValues: {
      username: state.accountState.tempAccount.email || state.accountState.tempAccount.phone
    }
  }), { forgotPassword }
)(AccountForgotPasswordContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/ForgotPassword/AccountForgotPassword/AccountForgotPassword.tsx